export default __webpack_public_path__ + "static/media/discounts-welcome-image.8926a0f3.svg";